<template>
  <pdl-dialog
    :visible="isDialogVisible"
    :append-to-body="true"
    :width="breakpointConfig.width"
    :top="breakpointConfig.top"
    :fullscreen="breakpointConfig.fullscreen"
    :z-index="9999"
    :title="learnMoreDialogTitle"
    :close-dialog-tool-tip="$t('popup.close')"
    qaid="sub-family-learn-more-dialog"
    @close="$emit('close')"
  >
    <pdl-card v-for="subFamily in subFamiliesWithDescriptions" :key="subFamily.familyName">
      <template #bodyContent>
        <div :qaid="`sub-family-description-card-${subFamily.familyName}`">
          <div class="flex justify-between items-center mb-2">
            <span class="text-sm font-bold" :qaid="`sub-family-description-title-${subFamily.familyName}`">
              {{ subFamily.familyName }}
            </span>
            <div
              v-if="getStartingAtPrice(subFamily)"
              class="text-sm"
              :qaid="`sub-family-description-price-${subFamily.familyName}`"
              v-html="$t('projectOne.card.startingAt', [getStartingAtPrice(subFamily)])"
            />
          </div>
          <p class="text-sm" :qaid="`sub-family-description-${subFamily.familyName}`">
            {{ subFamily.intro }}
          </p>
        </div>
      </template>
    </pdl-card>
  </pdl-dialog>
</template>

<script>
import {PdlDialog} from '@pedal/pdl-dialog';
import {PdlCard} from '@pedal/pdl-card';
import {mapState, mapGetters} from 'vuex';

export default {
  components: {
    PdlDialog,
    PdlCard,
  },
  props: {
    isDialogVisible: {
      type: Boolean,
      default: false,
    },
    subFamiliesWithDescriptions: {
      type: Array,
      required: true,
    },
    learnMoreDialogTitle: {
      type: String,
      default: '',
    },
  },
  computed: {
    ...mapState('viewSize', ['viewBreakpoint']),
    ...mapGetters('viewSize', ['viewBreakpointMoreThan']),
    ...mapGetters('familyDetails', ['isSubFamilyOnSale']),
    breakpointConfig() {
      return this.viewBreakpointMoreThan('small')
        ? {width: '75vw', top: '15vh', fullscreen: false}
        : {width: '100vw', top: '0vh', fullscreen: true};
    },
  },
  methods: {
    getStartingAtPrice(subfamily) {
      if (!subfamily?.startingAtPrice?.formatted) return null;
      const isOnSale = this.isSubFamilyOnSale(subfamily.models);
      return isOnSale
        ? `<span class="text-red-100">${subfamily?.startingAtPrice?.formatted}</span>`
        : subfamily?.startingAtPrice?.formatted;
    },
  },
};
</script>

<style lang="scss" scoped>
:deep(.pdl-card__body) {
  padding: 0.625rem;
  background-color: var(--gray-05);
}
</style>
